import { useState } from "react";
import { saveEventDetails } from "../Api/Event"; // API Call
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo"; // Import only Sample 14

const Event = () => {
  const [eventData, setEventData] = useState({
    EventName: "",
    EventType: "",
    EventDate: "",
    EventLocation: "",
    OrganizerName: "",
    BudgetAllocation: "",
    Department: "",
    ApprovalStatus: "",
  });

  const [loading, setLoading] = useState(false); // Loading State
  const navigate = useNavigate();

  const handleChange = (e) => {
    setEventData({ ...eventData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show Sample 14
    try {
      await saveEventDetails(eventData);
      toast.success(`🦄 Event Added Successfully`);
      setEventData({
        EventName: "",
        EventType: "",
        EventDate: "",
        EventLocation: "",
        OrganizerName: "",
        BudgetAllocation: "",
        Department: "",
        ApprovalStatus: "",
      });
      navigate("/viewEvent");
    } catch (error) {
      toast.error(`🦄 Some Error Happen`);
    } finally {
      setLoading(false); 
    }
  };

  return (
      <div className="main-content expand"> 
        <Container fluid className="fields-container">
          <h2 className="fields-title">Event Details</h2>

          {/* Show Sample 14 only when form is submitting */}
          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Event Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="EventName"
                    value={eventData.EventName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Event Type <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="EventType"
                    value={eventData.EventType}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Event Date <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="EventDate"
                    value={eventData.EventDate}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Event Location <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="EventLocation"
                    value={eventData.EventLocation}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Organizer Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="OrganizerName"
                    value={eventData.OrganizerName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Budget Allocation <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="number"
                    name="BudgetAllocation"
                    value={eventData.BudgetAllocation}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Department <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="Department"
                    value={eventData.Department}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
               
              <Col md={4}></Col>
            </Row>

            <div className="fields-btn-container">
              <Button variant="primary" type="submit" className="fields-submit" disabled={loading}>
                {loading ? "Saving..." : "Save Event"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default Event;